import { render, staticRenderFns } from "./SuccessDialog.vue?vue&type=template&id=3b67eee2&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./SuccessDialog.vue?vue&type=style&index=0&id=3b67eee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67eee2",
  null
  
)

export default component.exports